export const QUERY_REPORT_SEARCH_CRITERIA = `query ReportSearchCriteria{
  reportSearchCriteria {
    from
    to
    diameterValues
    lengthValues
  }
}
`